var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.42969C0 4.01141 3.58172 0.429688 8 0.429688C10.1217 0.429688 12.1566 1.27254 13.6569 2.77283C15.1571 4.27312 16 6.30796 16 8.42969C16 12.848 12.4183 16.4297 8 16.4297C3.58172 16.4297 0 12.848 0 8.42969ZM7.784 11.3177L11.44 6.51769V6.49369C11.6143 6.26504 11.6535 5.96074 11.5426 5.69543C11.4318 5.43012 11.1878 5.24409 10.9026 5.20743C10.6174 5.17077 10.3343 5.28904 10.16 5.51769L7.136 9.51769L5.832 7.85369C5.65623 7.6279 5.37334 7.51303 5.08992 7.55236C4.80649 7.59169 4.56557 7.77924 4.45792 8.04436C4.35026 8.30948 4.39223 8.6119 4.568 8.83769L6.52 11.3257C6.67266 11.5189 6.90578 11.631 7.152 11.6297C7.3996 11.6291 7.63297 11.5139 7.784 11.3177Z",
    fill: "#23C062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.81179a7b17fc9de1a856cbf3f17f8ebe.svg";
export { ForwardRef as ReactComponent };